export default __webpack_public_path__ + "static/media/wedding_music.1a4c0a9f.mp3";